import { cn } from '../lib/utils';

const statusConfig = {
  pending: { label: 'En attente', className: 'badge-warning' },
  in_progress: { label: 'En cours', className: 'bg-blue-500/20 text-blue-400 border border-blue-500/30' },
  completed: { label: 'Terminé', className: 'badge-ok' },
  cancelled: { label: 'Annulé', className: 'badge-error' },
  ok: { label: 'OK', className: 'badge-ok' },
  defect: { label: 'Défaut', className: 'badge-error' },
  na: { label: 'N/A', className: 'bg-slate-700/50 text-slate-400 border border-slate-600' },
  passed: { label: 'Réussi', className: 'badge-ok' },
  failed: { label: 'Échoué', className: 'badge-error' },
  driving: { label: 'Conduite', className: 'bg-amber-500/20 text-amber-400 border border-amber-500/30' },
  on_duty: { label: 'En service', className: 'bg-blue-500/20 text-blue-400 border border-blue-500/30' },
  off_duty: { label: 'Repos', className: 'bg-slate-700/50 text-slate-400 border border-slate-600' },
  sleeper: { label: 'Couchette', className: 'bg-purple-500/20 text-purple-400 border border-purple-500/30' },
  available: { label: 'Disponible', className: 'badge-ok' },
  in_use: { label: 'En utilisation', className: 'bg-blue-500/20 text-blue-400 border border-blue-500/30' },
  maintenance: { label: 'Maintenance', className: 'badge-warning' },
  delivery: { label: 'Livraison', className: 'bg-green-500/20 text-green-400 border border-green-500/30' },
  pickup: { label: 'Cueillette', className: 'bg-blue-500/20 text-blue-400 border border-blue-500/30' },
  pause: { label: 'Pause', className: 'bg-orange-500/20 text-orange-400 border border-orange-500/30' },
  draft: { label: 'Brouillon', className: 'bg-slate-700/50 text-slate-400 border border-slate-600' }
};

export const StatusBadge = ({ status, className, customLabel }) => {
  const config = statusConfig[status] || { label: status, className: 'bg-slate-700/50 text-slate-400 border border-slate-600' };
  
  return (
    <span 
      className={cn(
        'inline-flex items-center px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wide',
        config.className,
        className
      )}
      data-testid={`status-badge-${status}`}
    >
      {customLabel || config.label}
    </span>
  );
};

export default StatusBadge;
